import React, { useContext, useMemo } from 'react';
import { ReportsContainerContext, IReportsContainerContext } from './reportsContainerState/reportsContainerContext';
import { IEditRestaurantContext, EditRestaurantContext } from '../../../../editRestaurantState/editRestaurantContext';
import { TIPS_JAR_CLIENT_TYPE } from 'appConstants';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import ReportsState from './components/ReportsForm/reportsContext/reportsState/ReportsState';
import ReportsForm from './components/ReportsForm/ReportsForm';
import AddNewReportBtn from './components/AddNewReportBtn';
import ModalWindows from './components/ModalWindows';
import classNames from 'classnames';
import style from './ReportsContainer.module.scss';

interface IProps {
	isVisible: boolean;
}

export const ReportsContainer: React.FC<IProps> = React.memo(({ isVisible }) => {
	const { addNewReport, reports } = useContext<IReportsContainerContext>(ReportsContainerContext);
	const { clientType } = useContext<IEditRestaurantContext>(EditRestaurantContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const reportForms = useMemo(() => {
		return reports.map((report, i) => (
			<ReportsState key={report.id + String(i)}>
				<ReportsForm report={report} />
			</ReportsState>
		));
	}, [reports]);

	return (
		<div className={containerClasses} data-test="ReportsContainer">
			<Text
				translationNameSpace="form"
				translationKey="reportsHeading"
				theme="secondary"
				size="l"
				weight="bold"
			/>
			{clientType === TIPS_JAR_CLIENT_TYPE && (
				<div className={style.tipsJarInfo}>
					<Icon name={IconName.info} size="lg" className={style.tipsJarInfoIcon} />
					<Text
						translationNameSpace="form"
						translationKey="reportsTipsJarInfo"
						theme="neutralMedium"
						size="m"
						weight="medium"
					/>
				</div>
			)}
			{reports.length ? reportForms : <div className={style.divider} />}
			<AddNewReportBtn addNewReport={addNewReport} />
			<ModalWindows />
		</div>
	);
});
